module.exports = "<div class=\"add-category-modal\">\n   <div class=\"add-category-header\">{{data.title}}</div>\n\n       <div class=\"control-container message-data\">\n        <p>{{data.message}}</p>\n       </div>\n\n\n   <div class=\"add-category-footer\">\n       <button class=\"btn btn-default\" [mat-dialog-close]=\"\">Ok</button>\n       <button class=\"btn btn-default\" mat-dialog-close>Cancel</button>\n   </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dialogs/message-dialog/message-dialog.component.html
// module id = 1915
// module chunks = 0